import React, { FC } from "react";
import { Steps } from "../../atoms/Steps";
import { Content, StepsDiv } from "./elements";
import { ApplicantDetailsStepperProps } from "./types";
import { theme } from "../../../config";
import { ApplicantPreScreeningForm } from "../ApplicantPreScreeningForm";
import { useMediaQuery } from "react-responsive";

const ApplicantDetailsStepper: FC<ApplicantDetailsStepperProps> = (props) => {
  const { current, steps, ...others } = props;

  const isTabletOrMobile = useMediaQuery({
    query: theme.breakpoints.mobileAndTablet,
  });

  return (
    <>
      {current < 3 && (
        <StepsDiv>
          <Steps
            steps={steps}
            current={current}
            size={isTabletOrMobile ? "small" : "default"}
          />
        </StepsDiv>
      )}
      <Content>
        {current < 3 ? (
          steps[current].content
        ) : (
          <ApplicantPreScreeningForm {...others} />
        )}
      </Content>
    </>
  );
};

export default ApplicantDetailsStepper;
